import { useEffect, useRef, useState } from 'react';
// import { IPerformanceProduto } from '@core/models';
// import api from '@core/services/api';
import { Box, Button, Container, Fade, Input, Link } from '@mui/material';
import { BrowserQRCodeReader, IScannerControls } from '@zxing/browser';
import { colors } from '@assets/colors';
import { ReactComponent as QrLogoSTZ } from '@assets/qr-stz-logo.svg';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { PerformanceProduto } from './components/performance';
import { LoadingView } from '@core/components';
import { AlertComponent } from '@core/components/atoms/alert-component';
import { varejoService } from '@core/services/varejo/varejo.service';
import { useAppSelector } from '@store/hooks';
import { selectorPerformanceProduto } from '@core/slice/performanceProduto.slice';
import { isFilled, isObjectEmpty } from '@core/utils';

interface IConsultaProdutoProps {}

export function ConsultaProduto(props: IConsultaProdutoProps) {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const codeReaderRef = useRef<BrowserQRCodeReader | null>(null);
    const [scannerControls, setScannerControls] = useState<IScannerControls | null>(null);

    const [paused, setPaused] = useState(true);
    const [loja, setLoja] = useState<string>('');
    const [produto, setProduto] = useState<string>('');

    const { data, loading, error } = useAppSelector(selectorPerformanceProduto);

    useEffect(() => {
        codeReaderRef.current = new BrowserQRCodeReader();

        return () => {
            if (scannerControls) {
                scannerControls.stop();
            }
        };
    }, [scannerControls]);

    const startScanning = async () => {
        if (!videoRef.current || !codeReaderRef.current) return;

        const constraints = {
            video: {
                facingMode: 'environment',
                width: { ideal: 640 },
                height: { ideal: 480 }
            }
        };

        setPaused(false);

        try {
            const controls = await codeReaderRef.current.decodeFromConstraints(constraints, videoRef.current, (result) => {
                if (result) {
                    const url = result.getText();

                    extractLojaAndProduto(url);

                    controls.stop();
                    setScannerControls(null);
                }
            });
            setScannerControls(controls);
        } catch (err) {
            console.error('Error starting scanner:', err);
        }
    };

    const resetScanning = () => {
        if (scannerControls) {
            scannerControls.stop();
        }
    };

    const extractLojaAndProduto = (url: string) => {
        const match = url.match(/https?:\/\/\S+\/(\d{4})\/(\d+)/);
        if (match) {
            const lojaValue = match[1];
            const produtoValue = match[2].substring(0, 7);
            setLoja(lojaValue);
            setProduto(produtoValue);

            buscarPerformanceProduto(lojaValue, produtoValue);
        } else {
            console.warn('URL does not match expected pattern.');
            setLoja('');
            setProduto('');
        }
    };

    const buscarPerformanceProduto = async (loja: string, produto: string) => {
        if (loja && produto) {
            varejoService.buscarPerformanceProduto(loja, produto);

            setPaused(true);
        } else {
            console.warn('Loja or Produto is empty.');
        }
    };

    return (
        <Container maxWidth="sm" sx={{ px: '0', mt: '-24px' }}>
            <Box py="0.5rem" px="1.5rem" display="flex" justifyContent="space-between" justifyItems="center" gap="8px" bgcolor={colors.gray7}>
                <Input
                    type="text"
                    id="loja"
                    name="loja"
                    placeholder="Loja"
                    required
                    sx={{ width: '4.5rem', px: '0.5rem', backgroundColor: colors.white0, fontSize: '11px', borderRadius: '4px' }}
                    value={loja}
                    onChange={(e) => setLoja(e.target.value)}
                />
                <Input
                    type="text"
                    id="produto"
                    name="produto"
                    placeholder="produto"
                    required
                    sx={{ width: '4.5rem', px: '0.5rem', backgroundColor: colors.white0, fontSize: '11px', borderRadius: '4px' }}
                    value={produto}
                    onChange={(e) => setProduto(e.target.value)}
                />
                <Button size="small" variant="contained" sx={{ fontSize: '11px', width: '74px', py: '8px' }} onClick={() => buscarPerformanceProduto(loja, produto)}>
                    Consultar
                </Button>
                <Button variant="text" sx={{ fontSize: '11px', textTransform: 'capitalize', p: 0, gap: '4px' }} onClick={() => window.open(PathsEnum.PERFORMANCE_PRODUTO, '_self')}>
                    Ler QR Code
                    <QrLogoSTZ style={{ display: 'inline-flex', padding: 0, height: '28px', width: '28px', fill: '#000000' }} />
                </Button>
            </Box>

            {loading && <LoadingView />}
            {isFilled(error) && !loading ? (
                <Box p="1.5rem">
                    <AlertComponent type="error" detailed={true} message={error ?? '-'} />
                </Box>
            ) : (
                !isObjectEmpty(data) && (
                    <Box p="1.5rem">
                        <PerformanceProduto produto={data} />
                    </Box>
                )
            )}
            <Box p="1.5rem">
                {paused && !loading && isObjectEmpty(data) && (
                    <Box mt="5rem" py="0.375rem" px="1.5rem" display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="10px">
                        <Link href="#" style={{ height: 120, marginBottom: '15px' }}>
                            <QrLogoSTZ style={{ height: '100%', fill: '#000000' }} />
                        </Link>
                        {paused ? (
                            <Button variant="contained" sx={{ textTransform: 'capitalize' }} onClick={startScanning}>
                                Ler QR Code
                            </Button>
                        ) : (
                            <Button variant="contained" sx={{ textTransform: 'capitalize' }} onClick={resetScanning}>
                                Fechar
                            </Button>
                        )}
                    </Box>
                )}
            </Box>
            <Box p="1.5rem">
                <Fade in={!paused}>
                    <video ref={videoRef} style={{ maxWidth: '100%', borderRadius: '8px' }} />
                </Fade>
            </Box>
        </Container>
    );
}
